import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { Modal, ModalComponent } from 'remarketing-ui-components-lib';
import { ActionSubmittingComponent } from 'src/search/components/modal-actions/action-submitting/action-submitting.component';
import { ActionSubmittedComponent } from '../modal-actions/action-submitted/action-submitted.component';
import { ActionErrorComponent } from '../modal-actions/action-error/action-error.component';


@Component({
    selector: 'lib-save-comment-modal',
    templateUrl: './save-comment-modal.component.html',
    styleUrls: ['./save-comment-modal.component.scss'],
    imports: [
        TranslocoDirective,
        ModalComponent,
        ActionSubmittingComponent,
        ActionSubmittedComponent,
        ActionErrorComponent
    ]
})
export class SaveCommentModalComponent implements OnDestroy, Modal {
  @Output() closed = new EventEmitter<void>();
  @ViewChild(ModalComponent) modal: ModalComponent;
  tenantName = '';
  state: 'loading' | 'success' | 'error' = 'loading';
  @Input() errorText: string;

  constructor(private readonly changeDetector: ChangeDetectorRef) {}

  close() {
    this.modal.close();
  }
  show() {
    this.changeDetector.markForCheck();
    this.modal.show();
  }

  ngOnDestroy(): void {
    if (this.modal) {
      this.modal.close();
    }
  }
}
